import styled from 'styled-components'
import Accordion from '@mui/material/Accordion'
import AccordionSummary from '@mui/material/AccordionSummary'
import AccordionDetails from '@mui/material/AccordionDetails'

export const StyledAccordion = styled(Accordion)<{
  background?: 'primary' | 'secondary'
  radius?: 'none' | 'standard'
}>`
  border-radius: 8px;
  margin: 0 !important;

  &:before {
    display: none;
  }

  &.Mui-expanded {
    margin: 0 !important;
  }

  &.MuiAccordion-root {
    background-color: ${(p) =>
      p.background === 'secondary'
        ? p.theme.NOTIFICATION
        : p.theme.WHITE} !important;
    border: ${(p) =>
      p.background === 'secondary'
        ? 'none'
        : `2px solid ${p.theme.SECONDARY}`} !important;
    box-shadow: none !important;
    border-radius: ${(p) =>
      p.radius === 'none' ? '0px' : p.theme.space.s} !important;
  }
`

export const StyledAccordionSummary = styled(AccordionSummary)`
  min-height: 48px !important;

  &.Mui-expanded {
    min-height: 48px !important;
  }

  .MuiAccordionSummary-content {
    margin: 12px 0 !important;
  }

  .MuiAccordionSummary-content.Mui-expanded {
    margin: 12px 0 !important;
  }
`

export const StyledAccordionDetails = styled(AccordionDetails)`
  padding-top: 8px !important;

  @media only screen and (max-width: ${(p) => p.theme.vp}px) {
    max-height: calc(100vh - 500px);
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }
`
